export const getTagString = (tags) => {
  if (!tags) {
    return null
  }
  const tagStrings = []

  const tagsArr = [...tags]
  tagsArr.forEach((tag) => {
    tagStrings.push([...tag].reverse().join(' > '))
  })
  
  return tagStrings.join(', ')
}